@if (_uiSref) {
  <a [uiSref]="_uiSref" [uiParams]="_item.uiParams" uiSrefActive="link-active"
    (uiSrefStatus)="statusChanged(_item.id, $event.active)">
    <ng-container *ngTemplateOutlet="linkContent;context:{$implicit:_item,useIcon:useIcon}"></ng-container>
  </a>
} @else {
  <a href="#" (click)="submenuToggle($event)">
    <ng-container *ngTemplateOutlet="linkContent;context:{$implicit:_item,useIcon:useIcon}"></ng-container>
  </a>
}
@if (_item.submenu && _item.submenu.length > 0) {
  <ul>
    @for (subItem of _item.submenu; track subItem.id) {
      <li
        [opMenuItem]="subItem"
        [menuAccordionMode]="menuAccordionMode"
        (uiSrefStatus)="statusChanged(subItem.id,$event.active)"
        [useIcon]="false">
      </li>
    }
  </ul>
}

<ng-template #linkContent let-item let-icon="useIcon">
  @if (icon) {
    <span class="icon"><i class="material-icons" [innerHTML]="item.icon"></i></span>
  }
  <span [ngClass]="{ 'menu_title': icon }" [innerHTML]="item.title"></span>
  @if (item.beta) {
    <sup class="beta">BETA</sup>
  }
</ng-template>
